export function MapGlyph() {
  return (
    <svg viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
      <path d="M7 2 2 4v14l5-2 6 2 5-2V2l-5 2-6-2zm0 2.2 6 2v11.6l-6-2V4.2z" />
    </svg>
  );
}
export function BarsGlyph() {
  return (
    <svg viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
      <path d="M3 12h3v6H3zM8 6h3v12H8zM13 9h3v9h-3z" />
    </svg>
  );
}
export function PeopleGlyph() {
  return (
    <svg viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
      <path d="M7 9a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm6 1a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5zM1 17c0-3 3-5 6-5s6 2 6 5v1H1v-1zm13-1c0-1.4-.6-2.6-1.6-3.5C14 12 16 13 16 15v3h3v-1c0-2-2-3.5-5-5z" />
    </svg>
  );
}
export function PersonGlyph() {
  return (
    <svg viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
      <path d="M10 10a4 4 0 1 0 0-8 4 4 0 0 0 0 8zm0 2c-4 0-7 2-7 5v1h14v-1c0-3-3-5-7-5z" />
    </svg>
  );
}

export function RouteGlyph() {
  return (
    <svg viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
      <path d="M5.5 2a2.5 2.5 0 0 0-.8 4.87C4.2 9.1 3 9.9 3 12a4 4 0 0 0 4 4h5.1a2.5 2.5 0 1 0 0-1.5H7a2.5 2.5 0 0 1 0-5h6a4 4 0 0 0 0-8H8.4A2.5 2.5 0 0 0 5.5 2zm0 1.5a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
    </svg>
  );
}
